module.exports = __webpack_public_path__ + "img/6_119.0fb628c9.png";